module.exports = __webpack_public_path__ + "img/circle-p.5991f818.svg";